import instance from "../utils/network";

export interface PubProductResponse {
  id: number;
  pubId: number;
  name: string;
  price: number;
  imageUrl: string | null;
}

export interface PayPubProductDto {
  pubProductId: number;
  count: number;
}
export interface PayPubProductInAppRequest {
  pubId: number;
  payPubProductDtos: PayPubProductDto[];
  memo: string;
  table?: string | null;
  seat?: number | null;
  isPickUp: boolean;
}

export function getPubProducts(pubId: number): Promise<PubProductResponse[]> {
  return instance.get("/nest/pub-product/" + pubId);
}

export function payPubProductInApp(
  request: PayPubProductInAppRequest
): Promise<void> {
  return instance.post("/nest/pub-product/pay-in-app", request);
}
